import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import Header from '../components/header/Header';
import JobSafetyAnalysisForm from '../components/forms/JobSafetyAnalysisForm';
import SavedForms from '../components/forms/SavedForms';
import SubmittedForms from '../components/forms/SubmittedForms';
import EditForm from '../components/forms/EditForm';
import MainPage from '../components/main/MainPageNew';
import TBTList from '../components/tbt/TBTList';
import TBTForm from '../components/tbt/TBTForm';
import Sync from '../components/sync/Sync';
import WeeklyRosterImproved from '../components/admin/WeeklyRosterImproved';
import DBTest from '../components/admin/DBTest';
// AdminChat disabled
// import AdminChat from '../components/admin/AdminChat';
import { TrainingPage } from "../components/training/TrainingPage";
import MepForm from "../components/training/forms/mep/MepForm";
import FtForm from "../components/training/forms/ft/FtForm";
import JobGlCaptureForm from "../components/creditCart/JobGlCaptureForm"
import TrainingDue from "../components/training/trainingDue/TrainingDue";
import TrainingDueDefaultForm from "../components/training/forms/default/TrainingDueDefaultForm";
import WeldingQvalForm from "../components/training/forms/welding/WeldingQvalForm";
import TrainingSessionsList from "../components/training-sessions/TrainingSessionsList";
import TrainingSessionForm from "../components/training-sessions/TrainingSessionForm";
import TrainingSessionDetail from "../components/training-sessions/TrainingSessionDetail";
import SSDDetail from "../components/ssd/SSDDetail";
import JhaGeneralStep from "../components/jha/step1/JhaStepOne";
import JHAPage from "../components/jha/JHAPage";
import JhaDocsStep from "../components/jha/step2/JhaStepTwo";
import JhaActivitiesStep from "../components/jha/step3/index";
import JhaCrewStep from "../components/jha/stepCrew/JhaCrewStep";
import JhaFinalStep from "../components/jha/step4/JhaStepFour";
import JhaViewer from "../components/jha/JhaViewer";
import DailyLog from "../components/DailyLog/DailyLog";
import IncidentDraftList from "../components/incidents/IncidentDraftList";
import IncidentFormStep1New from "../components/incidents/IncidentFormStep1New";
import IncidentFormMain from "../components/incidents/IncidentFormMain";
import OSHAGuidelines from "../components/safety/OSHAGuidelines";
import VendorsPage from "../components/vendors/VendorsPage";
import EmployeesPage from "../components/employees/EmployeesPage";
import SdsList from "../components/sds/SdsList";
import TempExhibitB from "../components/temps/TempExhibitB";
import TempExhibitBList from "../components/temps/TempExhibitBList";
import TimesheetPage from "../components/timesheet/TimesheetPage";
import PtoRequestPage from "../components/timesheet/pto/PtoRequestPage";
import POPage from "../components/po/POPage";
import ToolsPage from "../components/tools/ToolsPage";
import PostWorkAreaTurnoverForm from "../components/forms/PostWorkAreaTurnoverForm";
import PostWorkAreaTurnoverList from "../components/forms/PostWorkAreaTurnoverList";
import EmployeeWarningNoticeForm from "../components/forms/EmployeeWarningNoticeForm";
import EmployeeWarningNoticeList from "../components/forms/EmployeeWarningNoticeList";
import PipingInformation from "../components/piping/information/PipingInformation";
import PipingForms from "../components/piping/forms/PipingForms";
import PipeHydroTestForm from "../components/piping/forms/PipeHydroTestForm";
import PipeHydroTestList from "../components/piping/forms/PipeHydroTestList";
import GeneralTorqueProcedure from "../components/piping/information/GeneralTorqueProcedure";
import FlangeSpecifications from "../components/piping/information/FlangeSpecifications";
import PipingGeneralTesting from "../components/piping/information/PipingGeneralTesting";
import VesselHydroTestForm from "../components/piping/forms/VesselHydroTestForm";
import VesselHydroTestList from "../components/piping/forms/VesselHydroTestList";
import ServiceLeakTestForm from "../components/piping/forms/ServiceLeakTestForm";
import ServiceLeakTestList from "../components/piping/forms/ServiceLeakTestList";
import WeldMapForm from "../components/piping/forms/WeldMapForm";
import WeldMapList from "../components/piping/forms/WeldMapList";
import PneumaticTestForm from "../components/piping/forms/PneumaticTestForm";
import PneumaticTestList from "../components/piping/forms/PneumaticTestList";
import TorqueMapForm from "../components/piping/forms/TorqueMapForm";
import TorqueMapList from "../components/piping/forms/TorqueMapList";
import GasLineInspectionForm from "../components/piping/forms/GasLineInspectionForm";
import GasLineInspectionList from "../components/piping/forms/GasLineInspectionList";
import MeggerTestForm from "../components/electrical/forms/MeggerTestForm";
import MeggerTestList from "../components/electrical/forms/MeggerTestList";
import TerminalTorqueTestForm from "../components/electrical/forms/TerminalTorqueTestForm";
import TerminalTorqueTestList from "../components/electrical/forms/TerminalTorqueTestList";
import PanelShopQcForm from "../components/electrical/forms/PanelShopQcForm";
import PanelShopQcList from "../components/electrical/forms/PanelShopQcList";
import BusInspectionForm from "../components/electrical/forms/BusInspectionForm";
import BusInspectionList from "../components/electrical/forms/BusInspectionList";
import CableWiringScheduleForm from "../components/electrical/forms/CableWiringScheduleForm";
import CableWiringScheduleList from "../components/electrical/forms/CableWiringScheduleList";
import EnergizedWorkPermitForm from "../components/electrical/forms/EnergizedWorkPermitForm";
import EnergizedWorkPermitList from "../components/electrical/forms/EnergizedWorkPermitList";
import PackingSlipForm from "../components/electrical/forms/PackingSlipForm";
import PackingSlipList from "../components/electrical/forms/PackingSlipList";
import SafetySchedulePage from "../components/safety/SafetySchedulePage";
import SafetyScheduleGroupView from "../components/safety/SafetyScheduleGroupView";
import JobSiteSafetyInspectionForm from "../components/safety/forms/JobSiteSafetyInspectionForm";
import JobSiteSafetyInspectionList from "../components/safety/forms/JobSiteSafetyInspectionList";
import OperatorPracticalEvaluationForm from "../components/safety/forms/OperatorPracticalEvaluationForm";
import OperatorPracticalEvaluationList from "../components/safety/forms/OperatorPracticalEvaluationList";
import PracticalEvaluationTypePicker from "../components/safety/forms/PracticalEvaluationTypePicker";
import PracticalEvaluationForm from "../components/safety/forms/PracticalEvaluationForm";
import PracticalEvaluationList from "../components/safety/forms/PracticalEvaluationList";
import ForkliftProficiencyList from "../components/safety/forms/ForkliftProficiencyList";
import ChangeOrderForm from "../components/operations/forms/ChangeOrderForm";
import ChangeOrderList from "../components/operations/forms/ChangeOrderList";
import SowForm from "../components/operations/forms/SowForm";
// SowList removed — SOW is now a read-only viewer
import WarrantyForm from "../components/operations/forms/WarrantyForm";
import WarrantyList from "../components/operations/forms/WarrantyList";
import WelderQualificationReleaseForm from "../components/operations/forms/WelderQualificationReleaseForm";
import WelderQualificationReleaseList from "../components/operations/forms/WelderQualificationReleaseList";
import LiftEvaluationForm from "../components/operations/forms/LiftEvaluationForm";
import LiftEvaluationList from "../components/operations/forms/LiftEvaluationList";
import LiftTruckPmForm from "../components/operations/forms/LiftTruckPmForm";
import LiftTruckPmList from "../components/operations/forms/LiftTruckPmList";
import EquipmentList from "../components/operations/EquipmentList";
import SpotterTrainingForm from "../components/training/forms/SpotterTrainingForm";
import SpotterTrainingList from "../components/training/forms/SpotterTrainingList";
import CsepList from "../components/csep/CsepList";
import CsepStepOne from "../components/csep/step1/CsepStepOne";
import CsepStepTwo from "../components/csep/step2/CsepStepTwo";
import LttList from "../components/ltt/LttList";
import LttForm from "../components/ltt/LttForm";
import ContinuousImprovementForm from "../components/ci/ContinuousImprovementForm";
import GasMonitorTestList from "../components/operations/gas-monitor/GasMonitorTestList";
import GasMonitorTestForm from "../components/operations/gas-monitor/GasMonitorTestForm";
import SrdInspectionList from "../components/operations/srd-inspection/SrdInspectionList";
import SrdInspectionForm from "../components/operations/srd-inspection/SrdInspectionForm";
import FallArrestRescuePlanList from "../components/safety/forms/FallArrestRescuePlanList";
import FallArrestRescuePlanForm from "../components/safety/forms/FallArrestRescuePlanForm";
import ExtEquipmentScan from "../components/operations/ext-equipment/ExtEquipmentScan";
import ExtEquipmentLinkForm from "../components/operations/ext-equipment/ExtEquipmentLinkForm";
import ExtEquipmentInspectionForm from "../components/operations/ext-equipment/ExtEquipmentInspectionForm";
import ExtEquipmentDailyCheck from "../components/operations/ext-equipment/ExtEquipmentDailyCheck";
import ExtEquipmentProfile from "../components/operations/ext-equipment/ExtEquipmentProfile";

function AuthenticatedLayout({ handleLogout, onShowUpdateModal, waitingWorker }) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh', // экранная высота
            }}
        >
            <Header handleLogout={handleLogout} />
            {/* Контентный контейнер занимает всё доступное пространство */}
            <Box sx={{
                flex: 1,
                paddingTop: '60px', /* отступ под хедер */
                width: '100%',
                boxSizing: 'border-box'
            }}>
                <Container
                    maxWidth={false}
                    sx={{
                        padding: '0 !important',
                        width: '100%',
                        boxSizing: 'border-box'
                    }}
                >
                    <Routes>
                        <Route path="/jsa" element={<JobSafetyAnalysisForm />} />
                        <Route path="/jsa/saved" element={<SavedForms />} />
                        <Route path="/jsa/submitted" element={<SubmittedForms />} />
                        <Route path="/jsa/edit/:id" element={<EditForm />} />

                        <Route path="/tbt" element={<TBTList />} />
                        <Route path="/tbt/:id/edit" element={<TBTForm />} />

                        <Route path="/cc" element={<JobGlCaptureForm />} />

                        <Route path="/po" element={<POPage />} />
                        <Route path="/timesheet" element={<TimesheetPage />} />
                        <Route path="/timesheet/pto" element={<PtoRequestPage />} />
                        <Route path="/main" element={<MainPage />} />
                        <Route path="/" element={<MainPage />} />

                        <Route path="/admin/synchronization" element={<Sync />} />
                        <Route path="/admin/weekly-employee" element={<WeeklyRosterImproved />} />
                        <Route path="/admin/db-test" element={<DBTest />} />
                        {/* AdminChat disabled */}


                        <Route path="/training" element={<TrainingPage />} />

                        {/* Training Due pages */}
                        <Route path="/training-due" element={<TrainingDue />} />
                        <Route path="/training-due/default" element={<TrainingDueDefaultForm />} />
                        <Route path="/training-due/mep" element={<MepForm />} />
                        <Route path="/training-due/ft" element={<FtForm />} />
                        <Route path="/training-due/welding" element={<WeldingQvalForm />} />
                        <Route path="/training-due/operator-practical-evaluation" element={<OperatorPracticalEvaluationForm />} />

                        {/* Safety stand down */}
                        <Route path="/ssd" element={<SSDDetail />} />

                        {/* Job Hazard Analysis */}
                        <Route path="/jha" element={<JHAPage />} />
                        <Route path="/jha/step-1" element={<JhaGeneralStep />} />
                        {/* Steps swapped: position 2 = Work Activities+Energy, position 3 = Documents.
                            Data keys stay unchanged (stepTwo=docs, stepThree=activities) — only presentation order changed. */}
                        <Route path="/jha/step-2" element={<JhaActivitiesStep />} />
                        <Route path="/jha/step-3" element={<JhaDocsStep />} />
                        <Route path="/jha/step-4" element={<JhaCrewStep />} />
                        <Route path="/jha/step-5" element={<JhaFinalStep />} />
                        <Route path="/jha/view/:id" element={<JhaViewer />} />

                        {/* Daily Log */}
                        <Route path="/daily-log" element={<DailyLog />} />

                        {/* Initial Incident Communications */}
                        <Route path="/incidents" element={<IncidentDraftList />} />
                        <Route path="/incidents/:id/edit" element={<IncidentFormStep1New />} />
                        <Route path="/incidents/:id/report" element={<IncidentFormMain />} />

                        {/* OSHA/DHEC Guidelines */}
                        <Route path="/osha-guidelines" element={<OSHAGuidelines />} />

                        {/* Vendors */}
                        <Route path="/vendors" element={<VendorsPage />} />

                        {/* Employees */}
                        <Route path="/employees" element={<EmployeesPage />} />
                        <Route path="/employees/list" element={<EmployeesPage />} />

                        {/* Hold Harmless Form */}
                        <Route path="/temps/exhibit-b" element={<TempExhibitB />} />
                        <Route path="/temps/exhibit-b/:id" element={<TempExhibitB />} />
                        <Route path="/temps/exhibit-b/list" element={<TempExhibitBList />} />

                        {/* Tools */}
                        <Route path="/tools" element={<ToolsPage />} />

                        {/* Unified Forms */}
                        <Route path="/forms/post-work-area-turnover" element={<PostWorkAreaTurnoverForm />} />
                        <Route path="/forms/post-work-area-turnover/list" element={<PostWorkAreaTurnoverList />} />
                        <Route path="/forms/employee-warning-notice" element={<EmployeeWarningNoticeForm />} />
                        <Route path="/forms/employee-warning-notice/list" element={<EmployeeWarningNoticeList />} />

                        {/* Piping */}
                        <Route path="/piping/information" element={<PipingInformation />} />
                        <Route path="/piping/information/general-torque-procedure" element={<GeneralTorqueProcedure />} />
                        <Route path="/piping/information/flange-specifications" element={<FlangeSpecifications />} />
                        <Route path="/piping/information/piping-general-testing" element={<PipingGeneralTesting />} />
                        <Route path="/piping/forms" element={<PipingForms />} />
                        <Route path="/piping/forms/pipe-hydro-test" element={<PipeHydroTestForm />} />
                        <Route path="/piping/forms/pipe-hydro-test/list" element={<PipeHydroTestList />} />
                        <Route path="/piping/forms/vessel-hydro-test" element={<VesselHydroTestForm />} />
                        <Route path="/piping/forms/vessel-hydro-test/list" element={<VesselHydroTestList />} />
                        <Route path="/piping/forms/service-leak-test" element={<ServiceLeakTestForm />} />
                        <Route path="/piping/forms/service-leak-test/list" element={<ServiceLeakTestList />} />
                        <Route path="/piping/forms/weld-map" element={<WeldMapForm />} />
                        <Route path="/piping/forms/weld-map/list" element={<WeldMapList />} />
                        <Route path="/piping/forms/pneumatic-test" element={<PneumaticTestForm />} />
                        <Route path="/piping/forms/pneumatic-test/list" element={<PneumaticTestList />} />
                        <Route path="/piping/forms/torque-map" element={<TorqueMapForm />} />
                        <Route path="/piping/forms/torque-map/list" element={<TorqueMapList />} />
                        <Route path="/piping/forms/gas-line-inspection" element={<GasLineInspectionForm />} />
                        <Route path="/piping/forms/gas-line-inspection/list" element={<GasLineInspectionList />} />

                        {/* Electrical */}
                        <Route path="/electrical/forms/megger-test" element={<MeggerTestForm />} />
                        <Route path="/electrical/forms/megger-test/new" element={<MeggerTestForm />} />
                        <Route path="/electrical/forms/megger-test/edit" element={<MeggerTestForm />} />
                        <Route path="/electrical/forms/megger-test/view" element={<MeggerTestForm />} />
                        <Route path="/electrical/forms/megger-test/list" element={<MeggerTestList />} />

                        <Route path="/electrical/forms/terminal-torque-test" element={<TerminalTorqueTestForm />} />
                        <Route path="/electrical/forms/terminal-torque-test/new" element={<TerminalTorqueTestForm />} />
                        <Route path="/electrical/forms/terminal-torque-test/edit" element={<TerminalTorqueTestForm />} />
                        <Route path="/electrical/forms/terminal-torque-test/view" element={<TerminalTorqueTestForm />} />
                        <Route path="/electrical/forms/terminal-torque-test/list" element={<TerminalTorqueTestList />} />

                        <Route path="/electrical/forms/panel-shop-qc" element={<PanelShopQcForm />} />
                        <Route path="/electrical/forms/panel-shop-qc/new" element={<PanelShopQcForm />} />
                        <Route path="/electrical/forms/panel-shop-qc/edit" element={<PanelShopQcForm />} />
                        <Route path="/electrical/forms/panel-shop-qc/view" element={<PanelShopQcForm />} />
                        <Route path="/electrical/forms/panel-shop-qc/list" element={<PanelShopQcList />} />

                        <Route path="/electrical/forms/bus-inspection/form" element={<BusInspectionForm />} />
                        <Route path="/electrical/forms/bus-inspection/list" element={<BusInspectionList />} />

                        <Route path="/electrical/cable-wiring-schedule" element={<CableWiringScheduleList />} />
                        <Route path="/electrical/cable-wiring-schedule/form" element={<CableWiringScheduleForm />} />

                        <Route path="/electrical/energized-work-permit" element={<EnergizedWorkPermitList />} />
                        <Route path="/electrical/energized-work-permit/form" element={<EnergizedWorkPermitForm />} />

                        <Route path="/electrical/packing-slip/list" element={<PackingSlipList />} />
                        <Route path="/electrical/packing-slip" element={<PackingSlipForm />} />

                        <Route path="/operations/change-order" element={<ChangeOrderList />} />
                        <Route path="/operations/change-order/form" element={<ChangeOrderForm />} />

                        <Route path="/operations/scope-of-work" element={<SowForm />} />

                        <Route path="/operations/warranty" element={<WarrantyList />} />
                        <Route path="/operations/warranty/form" element={<WarrantyForm />} />

                        <Route path="/operations/welder-qualification-release" element={<WelderQualificationReleaseList />} />
                        <Route path="/operations/welder-qualification-release/form" element={<WelderQualificationReleaseForm />} />
                        <Route path="/operations/lift-evaluation" element={<LiftEvaluationList />} />
                        <Route path="/operations/lift-evaluation/form" element={<LiftEvaluationForm />} />
                        <Route path="/operations/lift-truck-pm" element={<LiftTruckPmList />} />
                        <Route path="/operations/lift-truck-pm/form" element={<LiftTruckPmForm />} />

                        <Route path="/operations/equipment-list" element={<EquipmentList />} />

                        <Route path="/safety/schedule" element={<SafetySchedulePage />} />
                        <Route path="/safety/schedule/group" element={<SafetyScheduleGroupView />} />
                        <Route path="/safety/forms/job-site-safety-inspection" element={<JobSiteSafetyInspectionForm />} />
                        <Route path="/safety/forms/job-site-safety-inspection/new" element={<JobSiteSafetyInspectionForm />} />
                        <Route path="/safety/forms/job-site-safety-inspection/edit" element={<JobSiteSafetyInspectionForm />} />
                        <Route path="/safety/forms/job-site-safety-inspection/view" element={<JobSiteSafetyInspectionForm />} />
                        <Route path="/safety/forms/job-site-safety-inspection/list" element={<JobSiteSafetyInspectionList />} />

                        <Route path="/safety/forms/operator-practical-evaluation" element={<OperatorPracticalEvaluationForm />} />
                        <Route path="/safety/forms/operator-practical-evaluation/new" element={<OperatorPracticalEvaluationForm />} />
                        <Route path="/safety/forms/operator-practical-evaluation/edit" element={<OperatorPracticalEvaluationForm />} />
                        <Route path="/safety/forms/operator-practical-evaluation/view" element={<OperatorPracticalEvaluationForm />} />
                        <Route path="/safety/forms/operator-practical-evaluation/list" element={<OperatorPracticalEvaluationList />} />

                        <Route path="/training-due/practical-evaluation" element={<PracticalEvaluationList />} />
                        <Route path="/training-due/forklift-proficiency" element={<ForkliftProficiencyList />} />

                        {/* Training Sessions (Demo) */}
                        <Route path="/training-sessions" element={<TrainingSessionsList />} />
                        <Route path="/training-sessions/new" element={<TrainingSessionForm />} />
                        <Route path="/training-sessions/:uuid" element={<TrainingSessionDetail />} />
                        <Route path="/training-due/practical-evaluation/types" element={<PracticalEvaluationTypePicker />} />
                        <Route path="/training-due/practical-evaluation/:typeSlug/new" element={<PracticalEvaluationForm />} />
                        <Route path="/training-due/practical-evaluation/edit" element={<PracticalEvaluationForm />} />

                        {/* Confined Space Entry Permit */}
                        <Route path="/csep" element={<CsepList />} />
                        <Route path="/csep/step-1" element={<CsepStepOne />} />
                        <Route path="/csep/step-2" element={<CsepStepTwo />} />

                        {/* Lock-Tag-Try Permit */}
                        <Route path="/ltt" element={<LttList />} />
                        <Route path="/ltt/form" element={<LttForm />} />

                        {/* Training Forms */}
                        <Route path="/training/forms/spotter-training" element={<SpotterTrainingForm />} />
                        <Route path="/training/forms/spotter-training/list" element={<SpotterTrainingList />} />

                        {/* Gas Monitor Test */}
                        <Route path="/operations/gas-monitor-test" element={<GasMonitorTestList />} />
                        <Route path="/operations/gas-monitor-test/form" element={<GasMonitorTestForm />} />

                        {/* SRD Inspection */}
                        <Route path="/operations/srd-inspection" element={<SrdInspectionList />} />
                        <Route path="/operations/srd-inspection/form" element={<SrdInspectionForm />} />

                        {/* Fall Arrest Rescue Plan */}
                        <Route path="/safety/forms/fall-arrest-rescue-plan" element={<FallArrestRescuePlanList />} />
                        <Route path="/safety/forms/fall-arrest-rescue-plan/form" element={<FallArrestRescuePlanForm />} />

                        <Route path="/operations/ext-equipment/scan" element={<ExtEquipmentScan />} />
                        <Route path="/operations/ext-equipment/link" element={<ExtEquipmentLinkForm />} />
                        <Route path="/operations/ext-equipment/inspection" element={<ExtEquipmentInspectionForm />} />
                        <Route path="/operations/ext-equipment/daily-check" element={<ExtEquipmentDailyCheck />} />
                        <Route path="/operations/ext-equipment/profile" element={<ExtEquipmentProfile />} />

                        {/* Continuous Improvement */}
                        <Route path="/continuous-improvement" element={<ContinuousImprovementForm />} />

                        {/* Safety Data Sheets (SDS) */}
                        <Route path="/sds" element={<SdsList />} />

                    </Routes>
                </Container>
            </Box>
        </Box>
    );
}


export default AuthenticatedLayout;
